module.exports = __webpack_public_path__ + "static/media/poster.30b21866.svg";